module.exports = __webpack_public_path__ + "static/img/plan3.4083322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/zombs/plan3.png
// module id = T1mE
// module chunks = 35